module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "we-attachment"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "content upload-content"
  }, [_c('div', [_c('NbTank', {
    ref: "nbTank",
    attrs: {
      "tank": _vm.tank,
      "preview": false
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tank.exist()),
      expression: "tank.exist()"
    }],
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "gray",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelFunc($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.insertFunc($event)
      }
    }
  }, [_vm._v("插入")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-tab"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('a', {
    staticClass: "tab selected",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("上传附件")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-eae54838"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/common/fork/wangeditor/WEAttachment.vue
// module id = 1033
// module chunks = 1